import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardHome/DashboardLayout";
import LivestreamCard from "./livestreamCard";
import SocketManager from "../../socket/socketManager";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaFolderOpen } from "react-icons/fa";
import { getGoogleLocation } from "../../utils/utils";

function AllLivestream() {
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const [stream, setStream] = useState([]);
  const token = useSelector((state) => state.auth.accessToken);
  const navigate = useNavigate();
  const [currentLocation, setCurrentLocation] = useState({
    longitude: null,
    latitude: null,
  });

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setCurrentLocation({
          latitude: lat,
          longitude: lng,
        });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };
  
    fetchLocation();
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    SocketManager?.instance?.socket?.connect();
  }, []);

  useEffect(() => {
    SocketManager?.instance?.emitListLiveStream({
      lat: currentLocation?.latitude,
      lon: currentLocation?.longitude,
    });
    SocketManager?.instance?.listenListLiveStream((data) => {
      setStream(data);
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/dashboard/home");
    }
    // eslint-disable-next-line
  }, [token]);

  return (
    <DashboardLayout>
      {stream?.length === 0 && (
        <div className=" text-center h-[100vh] flex justify-center align-middle items-center">
          <div
            className={`${
              darktheme ? "bg-[black]" : "bg-white"
            } p-[4rem] rounded-[10px]`}
          >
            <FaFolderOpen className="w-20 h-20 mx-auto text-[#e5e6e5]" />
            <p>
              There are no streams available yet, your streams will show up.
              here.
            </p>
          </div>
        </div>
        // <div className=" gap-2 flex-col md:flex-row justify-center md:flex flexwrap mt-[2rem]">
        //   <LiveSkeletonLoader />
        //   <LiveSkeletonLoader />
        //   <LiveSkeletonLoader />
        // </div>
      )}
      <div className="flex flex-col justify-center gap-4 mt-[1rem] p-4">
        {stream &&
          stream?.map((item, index) => (
            <LivestreamCard stream={item} key={index} />
          ))}
      </div>
    </DashboardLayout>
  );
}
export default AllLivestream;
